<template>
    <div @keydown.enter="enterKey" v-show="!$store.state.user" class="auth-content">
        <div class="auth-modal">
            <img src="@/assets/logo.png" width="200" alt="Logo" />
            <hr>
            <div class="auth-title">{{ showRecoverPassword ? 'Esqueceu sua senha?' : 'Seja bem vindo, efetue seu login'}}</div>
            <div class="auth-sub-title" v-if="showRecoverPassword">Preecha seu endereço de e-mail e enviaremos instruções para redefinir sua senha.</div>
            <b-row>
                <b-col md="12" sm="12">
                    <b-form-group label="" label-for="email">
                        <b-form-input 
                            type="text"
                            id="email" 
                            name="email" 
                            ref="email" 
                            v-model.trim="user.email" 
                            maxlength="50" 
                            placeholder="E-mail">
                        </b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="!showRecoverPassword">
                <b-col md="12" sm="12">
                    <b-form-group label="" label-for="password">
                        <b-form-input 
                            type="password"
                            id="password" 
                            name="password" 
                            ref="password" 
                            v-model.trim="user.password" 
                            maxlength="15" 
                            placeholder="Senha">
                        </b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <hr>
            <b-button id="btn-principal" v-if="showRecoverPassword" @click="recoverpassword" variant="success" style="width: 100%;">Recuperar senha</b-button>
            <b-button id="btn-principal" v-else  @click="login" variant="success" style="width: 100%;">Acessar</b-button>           
            <a href @click.prevent="showRecoverPassword = !showRecoverPassword">
                <span v-if="showRecoverPassword">Voltar para login!</span>
                <span v-else>Esqueceu sua senha?</span>
            </a>
        </div>
    </div>
</template>

<script>
import { baseApiUrl, showError, userCredential } from '@/global'
import axios from 'axios'

export default {
    name: 'Auth',
    data() {
        return {
            showRecoverPassword: false,
            user: {},
            regex: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
        }
    },
    methods: {
        enterKey(){
            if(this.showRecoverPassword){
                this.recoverpassword()
            }else{
                this.login()
            }
        },
        login() {
            // Valida forçar preencher ambos os campos           
            let email = document.getElementById('email').value
            if (email == "") {
                this.$toasted.global.defaultError({ msg: 'Por favor, informar o e-mail'})
                document.getElementById('email').focus()
                return
            }
            let senha = document.getElementById('password').value
            if (senha == "") {
                this.$toasted.global.defaultError({ msg: 'Por favor, informar a senha'})
                document.getElementById('password').focus()
                return
            }            
            if(!this.regex.test(email)){
                this.$toasted.global.defaultError({ msg: 'Por favor, informar um e-mail valido '})
                document.getElementById('email').focus()
                return
            }
            axios.post(`${baseApiUrl}/login`, this.user)   //signin
                 .then(resp => {
                     // Status = 200 OK!
                     if (resp.data.status) {
                         // Se Login autenticado com sucesso, seta usuário logado na store 
                         this.$store.commit('setUser', resp.data)
                        
                         // Seta o usuário logado no localstorage 
                         localStorage.setItem(userCredential, JSON.stringify(resp.data))

                         // Após ter feito a autenticação navega para raiz
                         this.$router.push({ path: '/' })
                     } else 
                     {
                        // Status = Unauthorized
                        this.$toasted.global.defaultError({ msg: resp.data.mensagem })
                     }
                 })
                 .catch(showError)           
        },

        signup() {
            axios.post(`${baseApiUrl}/signup`, this.user)
                 .then(() => {
                     this.$toasted.global.defaultSuccess()
                     this.user = {}
                     this.showRecoverPassword = false
                 })
                 .catch(showError)
        },

        recoverpassword() {
            var email = document.getElementById('email').value
            if (email == "") {
                this.$toasted.global.defaultError({ msg: 'Por favor, informar o e-mail'})
                document.getElementById('email').focus()
                return
            }
            if(!this.regex.test(email)){
                this.$toasted.global.defaultError({ msg: 'Por favor, informar um e-mail valido '})
                document.getElementById('email').focus()
                return
            }
            axios.post(`${baseApiUrl}/recuperasenha`, this.user) 
                 .then(resp => {
                     // Status = OK - Email registrado!
                     if (resp.data.status) {
                         this.$toasted.global.defaultSuccess({ msg: resp.data.mensagem })
                         this.user = {}
                         this.showRecoverPassword = false
                     } else 
                     {
                        // Status = OK - Email NÃO registrado!
                        this.$toasted.global.defaultError({ msg: resp.data.mensagem })
                     }
                 })
                 .catch(showError)           
        }
	},
    mounted () {
        if(this.$store.state.user){
            this.$router.push({ path: '/' })
        }
    },
}
</script>

<style>
    .auth-content {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        width: 100%;
        top: 0;
        left: 0;
    }

    .auth-modal {
        background-color: #fff;
        width: 400px;
        padding: 25px;
        box-shadow: 0 1px 5px rgba(0, 0, 0, 0.15);
        display: flex;
        flex-direction: column;
        align-items: center;
        border-radius: 10px;        
    }    

    .auth-title {
        font-size: 1.2rem;
        font-weight: 400;
        margin-bottom: 15px;
    }

    .auth-sub-title {
        font-size: 1rem;
        margin-bottom: 25px;
        color: #666666;
    }
    
    .auth-modal input {
        width: 330px;
        margin-bottom: 15px;
    }

    .auth-modal button {
        align-self: center;
        margin-top: 10px;
        padding: 5px 15px;
        cursor: pointer;
    }

    .auth-modal a {
        margin-top: 15px;
        color: #666666;        
    }

    .auth-modal hr {
        border: 0;
        width: 100%;
        height: 1px;
        background-image: linear-gradient(to right,
            rgba(120, 120, 120, 0),
            rgba(120, 120, 120, 0.75),
            rgba(120, 120, 120, 0));
    }
</style>